// Internal modules
import { CRS_TAX_DETAILS_FIELDS } from './../constants';
import { dispatchFormAction } from '@/store';
import { CRS_NO_TIN_COUNTRIES } from '../../../lib/constants';
import { logger } from '@/lib/logger';

const removeTaxResidencyChangeHandler = (index, crsTaxDetails) => {
  const updatedState = [...crsTaxDetails];
  updatedState.splice(index, 1);
  dispatchFormAction({
    field: 'crsTaxDetails',
    payload: { value: updatedState },
  });
  logger.fpti('crs_remove_country_and_tax_details', {
    state_name: 'crs_section',
    total_tax_residencies: updatedState.length,
    transition_name: 'process_remove_country_click',
  });
};

const crsTaxDetailsChangeHandler = (
  newValue,
  attrChange,
  index,
  crsTaxDetails,
) => {
  const updatedState = [...crsTaxDetails];
  updatedState[index] = { ...updatedState[index] };

  const hasExistingBackendErrors = updatedState.some(
    taxDetail => taxDetail.taxPayerIdValue.isBackendError,
  );

  if (
    hasExistingBackendErrors &&
    attrChange === CRS_TAX_DETAILS_FIELDS.TAX_PAYER_ID_VALUE
  ) {
    /// Batch clearing of all the errors for TIN field only
    const clearedCrsDetails = crsTaxDetails.map((taxDetails, taxIndex) => ({
      ...taxDetails,
      taxPayerIdValue: {
        displayError: false,
        error: '',
        value: taxIndex === index ? newValue : taxDetails.taxPayerIdValue.value,
      },
    }));

    dispatchFormAction({
      field: 'crsTaxDetails',
      payload: { value: clearedCrsDetails },
    });
  } else {
    // Key ordering matters, validating the flow from 1st to last input
    const fields = Object.values(CRS_TAX_DETAILS_FIELDS);
    let shouldReset = false;

    fields.forEach(field => {
      if (shouldReset) {
        if (field !== CRS_TAX_DETAILS_FIELDS.TAX_PAYER_ID_TYPE) {
          updatedState[index][field] = {
            ...updatedState[index][field],
            displayError: false,
            error: '',
            value: '',
          };
        }
      } else if (field === attrChange) {
        if (field === CRS_TAX_DETAILS_FIELDS.TAX_PAYER_ID_TYPE) {
          updatedState[index][field] = newValue;
        } else {
          updatedState[index][field] = {
            ...updatedState[index][field],
            displayError: false,
            error: '',
            value: newValue,
          };
        }
        shouldReset = true;
      }
    });

    dispatchFormAction({
      field: 'crsTaxDetails',
      payload: { value: updatedState },
    });
  }
};

/**
 * @description Determines if the TIN field should be shown / hidden
 * based on the buyer country, tax residency country, and index
 * This method takes into consideration the CRS_NO_TIN_COUNTRIES list
 * Eg. Buyer country = AU and tax residency country = AU
 * don't show TIN field as AU is part of CRS_NO_TIN_COUNTRIES list
 * @param {string} buyerCountry - The buyer country
 * @param {string} taxResidencyCountry - The tax residency country
 * @param {number} index - The index of the tax residency
 * @returns {boolean} - Whether the TIN field should be shown
 */

const shouldShowTINField = (buyerCountry, taxResidencyCountry, index) => {
  if (CRS_NO_TIN_COUNTRIES.includes(buyerCountry)) {
    // Consideration for different tax residency countries based on index
    // For index 0: require tax residency to be selected first
    // For other indices: show TIN by default (when no tax residency selected)
    // For all indices: hide TIN only when tax residency equals buyer country
    if (index === 0 && !taxResidencyCountry) {
      return false;
    }
    return !taxResidencyCountry || taxResidencyCountry !== buyerCountry;
  }
  return true;
};

export {
  removeTaxResidencyChangeHandler,
  crsTaxDetailsChangeHandler,
  shouldShowTINField,
};
